import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import get from 'lodash/get';
import includes from 'lodash/includes';

import { normalizeString } from '@dmm/lib-common/lib/formatting';
import { hyphenateUrlComponents, generateSearchPath } from '../../../../../../../utils/urlHelpers/engines';
import {  translateMake } from '../../../../../../../utils/commonHelper';
import { ToolSetOptionsItem, ToolSetOptions } from '../../../../../../../components/ToolSet';
import { CollapsibleContent, CollapsibleHeader, Collapsible } from '../../../../../../../components/Collapsible';
import Link from '../../../../../../../components/SEO/Link';
import { getFilteredFacet, toggleSubFacet } from '../../../../../../../utils/multiFacetHelper';
import FilterTypeAhead from '../../../../../components/Filter/FilterTypeAhead';

import {getBoatConstantsFromI18n} from '../../../../../../../tppServices/translations/constants';
import { getMessages } from '../../../../../../../tppServices/translations/messages';

class FilterModel extends PureComponent {
  state = {
  }
  handleToggleModel(make, model){
    let { selectedMakeModels } = this.state;
    if (this.props.tracking) {
      this.handleTracking(make,model,selectedMakeModels);
    }
    let models = toggleSubFacet(make, model, selectedMakeModels, true);
    let newState = {
      selectedMakeModels: models
    };
    this.setState(newState);
    this.props.handleDataChange('makeModel', models);
  }

  handleTracking(make, model,selected) {
    let selectedModels = get(selected, make, []);
    if (includes(selectedModels, model)) {
      this.props.tracking.facetRemoved(`model removed - ${model}`);
    } else {
      let models = [];
      models.push(model);
      let trackingModel = {[make]: models};
      this.props.tracking.facetAdded({'makeModel': trackingModel});
    }
  }

  componentDidMount(){
    this.handlePropsUpdate();
  }
  componentDidUpdate(){
    this.handlePropsUpdate();
  }
  handlePropsUpdate(){
    if (this.props.makeModels !== undefined) {
      this.setState({
        selectedMakeModels: this.props.makeModels
      });
    }
  }
  renderModels(models, selectionCallback) {
    const messages = getMessages();
    const { make, position, makeModels, params, intl: { formatMessage: t } } = this.props;
    const { selectedMakeModels = makeModels } = this.state;
    const slugMake = normalizeString(hyphenateUrlComponents(make.value));
    return <ToolSetOptions>
      {
        models
          .map(model => {
            const slugModel = hyphenateUrlComponents(model.value, false);
            return <ToolSetOptionsItem
              type="checkbox"
              key={`Model-${slugModel}`}
              id={`Model-${slugModel}`}
              name={`${t(messages.model)}-${slugMake}-${position}`}
              value={slugModel}
              selected={includes(get(selectedMakeModels, slugMake, []), slugModel)}
              onClick={(value) => {
                this.handleToggleModel(slugMake, value);
                selectionCallback(value);
              }}>
              <Link className="model-link" href={generateSearchPath({ makeModel: toggleSubFacet(slugMake, slugModel, selectedMakeModels, true) }, params, true)} onClick={(e) => e.preventDefault()}>{model.value}</Link>
            </ToolSetOptionsItem>;
          })
      }
    </ToolSetOptions>;
  }
  render(){
    const boatConstants = getBoatConstantsFromI18n();
    const messages = getMessages();
    const { make, models = [], position, makeModels = {}, maxModelCount = boatConstants.MAX_MODEL_COUNT, params } = this.props;
    const { intl: { formatMessage: t } } = this.props;
    const { modal = [] } = params;
    const { selectedMakeModels = makeModels } = this.state;
    const slugMake = normalizeString(hyphenateUrlComponents(make.value));
    const allMakeModels = getFilteredFacet(models, []);
    let showAllModels = modal.includes('model');
    return <CollapsibleContent initialState="open" key={`MakeCollapsible-${slugMake}-${position}`} id={`MakeCollapsible-${slugMake}-${position}`}>
      <CollapsibleHeader priority={0}>
        {t(messages.model, {make: translateMake(make.value)})}
      </CollapsibleHeader>
      <Collapsible>
        <div className="search-filter model">
          <FilterTypeAhead
            items={allMakeModels}
            selectedItems={get(selectedMakeModels, slugMake)}
            id={`model-type-ahead-${slugMake}-${position}`}
            moreMessage="moreModels"
            placeholder={`${t(messages.modelPlaceholder, {make: translateMake(make.value)})}`}
            max={maxModelCount}
            render={(options, callback) => this.renderModels(options, callback)}
            showAll={showAllModels}
            url={generateSearchPath(params) + 'modal-model/'} />
        </div>
      </Collapsible>
    </CollapsibleContent>;
  }
}

FilterModel.propTypes = {
  handleDataChange: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  make: PropTypes.shape({
    value: PropTypes.string,
  }).isRequired,
  makeModels: PropTypes.object,
  maxMakeCount: PropTypes.number,
  maxModelCount: PropTypes.number,
  models: PropTypes.arrayOf(PropTypes.shape({
    count: PropTypes.number,
    value: PropTypes.string,
  })),
  params: PropTypes.shape({
    modal: PropTypes.string,
  }).isRequired,
  position: PropTypes.string,
  tracking: PropTypes.shape({
    facetAdded: PropTypes.func.isRequired,
    facetRemoved: PropTypes.func.isRequired,
  }),
};

export default injectIntl(FilterModel);
